export const CMP_PERIOD_PREVIOUS_PERIOD = "period-1";
export const CMP_PERIOD_PREVIOUS_YEAR = "year-1";

export const periods = {
    CMP_PERIOD_PREVIOUS_PERIOD,
    CMP_PERIOD_PREVIOUS_YEAR,
};
